import dynamic from "next/dynamic";
import { ComponentConfig } from "@zapier/builder.io-kit";

export const planCardCollectionConfig: ComponentConfig = {
  name: "PlanCardCollection",
  hideFromInsertMenu: true,
  category: "Pricing",
  component: dynamic(() => import("./PlanCardCollection")),
  includeScrollTracking: true,
  inputs: [
    {
      name: "plans",
      type: "list",
      subFields: [
        {
          name: "type",
          type: "string",
          enum: ["Free", "Starter", "Professional", "Team", "Company"],
          defaultValue: "Free",
        },
        {
          name: "description",
          type: "longText",
        },
        {
          name: "primaryCTA",
          friendlyName: "Primary CTA",
          type: "object",
          subFields: [
            {
              name: "color",
              type: "string",
              enum: ["primary", "primary-alt", "secondary"],
            },
            {
              name: "text",
              type: "string",
            },
            {
              name: "href",
              type: "string",
              helperText:
                "If left empty, the href will be automatically generated using the selected plan and currency",
            },
          ],
        },
        {
          name: "secondaryCTA",
          friendlyName: "Secondary CTA",
          type: "object",
          subFields: [
            {
              name: "text",
              type: "string",
            },
            {
              name: "href",
              type: "string",
            },
          ],
        },
        {
          name: "features",
          type: "list",
          subFields: [
            { name: "name", type: "string" },
            { name: "href", type: "string" },
            { name: "tooltip", type: "longText" },
          ],
        },
        {
          name: "hidePrice",
          type: "boolean",
        },
        {
          name: "priceDetails",
          type: "longText",
          helperText: "Only shown if price is hidden",
        },
        {
          name: "hideTasks",
          type: "boolean",
        },
      ],
    },
  ],
};
